/**
 * ID секции, для которой не отображается бейдж "с выгодой 5%"
 * Примеры: Смартфоны и гаджеты, или другие категории согласно бизнес-логике
 */
export const SECTION_ID_WITHOUT_BENEFITS = 263

/**
 * Процент выгоды при покупке товара с аксессуарами в комплекте
 */
export const ACCESSORIES_BENEFIT_PERCENT = 5
